import {
  type NavigationDestination,
  type NavigationPane,
} from 'src/utils/navigation/navigation.types';

export type QuickActionPagePane = Extract<NavigationPane, 'inbox' | 'search' | 'sidekick'>;

export type QuickActionPathPane = Extract<NavigationPane, 'home' | 'settings'>;

export type QuickActionPageTarget =
  | { kind: 'path'; path: string; navPane: QuickActionPathPane }
  | { kind: 'pane'; pane: QuickActionPagePane };

export interface QuickActionPage {
  id: string;
  title: string;
  iconData: NavigationDestination['iconData'];
  recordType?: string;
  target: QuickActionPageTarget;
}

export enum QuickActionPageGroupId {
  Workspace = 'workspace',
  Views = 'views',
  Settings = 'settings',
}

export interface QuickActionPageGroup {
  id: QuickActionPageGroupId;
  title: string;
  pages: QuickActionPage[];
}
